const en = {
    menu: {
        unConfig: 'URL not configured',
    },
    tabName: {
        dashboard: 'Dashboard',
    },
    button: {
        search: 'Search',
        reset: 'Reset',
        add: 'Add',
        edit: 'Edit',
        delete: 'Delete',
        confirm: 'Confirm',
        save: 'Save',
        cancel: 'Cancel',
        close: 'Close',
    },
    tip: {
        tip: 'Tips',
        success: 'Success',
        fail: 'Fail',
        delTip: 'Selected data will be deleted. Do you want to continue?',
    },
    login: {
        userName: 'User Name',
        account: 'Account',
        password: 'Password',
        btn: 'Log In',
        logout: 'Log Out',
    },
}
export default en;


// WEBPACK FOOTER //
// ./src/i18n/config/en.js